import {
  isPlainObject, isEmpty, head, keys, get
} from 'lodash';
import isNumeric from 'is-number';

import {ProbeProcessor} from '../types';

export const getState = (processor: ProbeProcessor, item) => {
  // state_range is always a map with one key
  const state = get(item, ['properties', 'state']);
  return state ? `"${state}"` : head(keys(processor.properties.state_range));
};

export const getMinMax = (processor: ProbeProcessor, item) => {
  let min, max;
  const stateRange = processor.properties.state_range;
  if (!isPlainObject(stateRange)) return {min, max};

  // state_range is always a map with one key
  const stateKey = head(keys(stateRange));
  const rangeMapValue = stateKey ? stateRange[stateKey] : null;
  if (isEmpty(rangeMapValue)) return {min, max};

  ({min, max} = rangeMapValue[0]);
  max = isNumeric(max) ? Number(max) : item.properties.range_max;
  min = isNumeric(min) ? Number(min) : item.properties.range_min;
  return {min, max};
};

export const getTimeWindow = (processor: ProbeProcessor, item) => {
  let timeWindow = processor.properties.time_window;
  timeWindow = isNumeric(timeWindow) ?
      Number(timeWindow) :
      item.properties.time_window;
  return timeWindow;
};
